import 'babel-polyfill';
import Placeholder from "./util/placeholder";
import Selection from "./whoareyou/selection";

const placeHolder1 = new Placeholder({
    el:"#placeHolder1"
});

window.selection = new Selection({
    el:"#contents",
    chtData:{
        tribe:"human",      // kamael, human, elf, dark, oak, dwarf
        gender:"male",      // male, female
        job:"death",        // death, warrior, wizard
    }
});

$(document).ready(function () {
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});
});


// WEBPACK FOOTER //
// ./src/js/whoareyou.js